import React from "react";
import Feedback from "./Feedback";
import HomeSlider from "./HomeSlider";
import HomeAbout from "./HomeAbout";
import HomeVideo from "./HomeVideo";
import HomeCourses from "./HomeCourses";
import HomeService from "./HomeServices";
import About from "./About"
import Gallery from "./Gallery"


function Home() {
  return (
    <div className="home">
      <HomeSlider />
       <About/>
      
      <HomeAbout />
        
      <HomeService />
      <HomeCourses />
       <Gallery/>
      {/* <HomeVideo /> */}
      <Feedback />
     
    </div>
  );
}

export default Home;
